import axios from 'axios'
import store from '@/store'
import { getToken, removeToken, setToken } from '@/utils/auth'

const http = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  withCredentials: true,
  xsrfCookieName: false,
  headers: {
    'Content-Type': 'application/json',
  },
})

http.interceptors.request.use((config) => {
  const token = getToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      removeToken()
      store.dispatch('auth/logout')
      if (window.location.pathname !== '/login') {
        window.location.assign('/login')
      }
    }
    return Promise.reject(error)
  }
)

export function bootstrapAuthHeader() {
  const token = getToken()
  if (token) setToken(token)
}

export default http
